import {
  Box,
  Button,
  Checkbox,
  FormControl,
  MenuItem,
  OutlinedInput,
  Select,
  Typography,
} from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import PropTypes from "prop-types";

const FILTER_TYPES = [
  "Event",
  "Task",
  "Reminder",
  "Holiday",
  "HalfDay",
  "Bond End",
  "Project Deadline",
  "Leave",
  "Public Holiday",
  "Day Celebration",
  "Company Event",
  "Employee Engagement Activity",
];

const FilterDropdown = ({
  selectedFilterTypes,
  onFilterChange,
  onSelectAll,
  onDeselectAll,
}) => {
  const renderFilterValue = (selected) => {
    if (!selected.length) return "Select type";
    const preview = selected.slice(0, 3).join(", ");
    const more = selected.length > 3 ? `, +${selected.length - 3}` : "";
    return preview + more;
  };

  return (
    <FormControl
      size="small"
      sx={{
        minWidth: 260,
        backgroundColor: "background.paper",
      }}
    >
      <Select
        multiple
        value={selectedFilterTypes}
        onChange={onFilterChange}
        input={<OutlinedInput />}
        displayEmpty
        renderValue={renderFilterValue}
        MenuProps={{
          PaperProps: {
            sx: { maxHeight: 400, width: 320 },
          },
        }}
      >
        <Box
          sx={{
            display: "flex",
            mt: 0,
            borderTop: 1,
            borderBottom: 1,
            borderColor: "divider",
          }}
        >
          <Button
            variant="text"
            onClick={onSelectAll}
            sx={{
              flex: 1,
              borderRight: 1,
              borderColor: "divider",
              borderRadius: 0,
              py: 1.2,
              fontWeight: 600,
              textTransform: "none",
            }}
          >
            Select All
          </Button>
          <Button
            variant="text"
            onClick={onDeselectAll}
            sx={{
              flex: 1,
              borderRadius: 0,
              py: 1.2,
              fontWeight: 600,
              textTransform: "none",
            }}
          >
            Deselect All
          </Button>
        </Box>
        {FILTER_TYPES.map((type) => {
          const checked = selectedFilterTypes.indexOf(type) > -1;
          return (
            <MenuItem key={type} value={type}>
              <Checkbox checked={checked} />
              <Typography sx={{ flexGrow: 1 }}>{type}</Typography>
              {checked && (
                <CheckIcon fontSize="small" sx={{ color: "primary.main" }} />
              )}
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  );
};

FilterDropdown.propTypes = {
  selectedFilterTypes: PropTypes.arrayOf(PropTypes.string).isRequired,
  onFilterChange: PropTypes.func.isRequired,
  onSelectAll: PropTypes.func.isRequired,
  onDeselectAll: PropTypes.func.isRequired,
};

export default FilterDropdown;
export { FILTER_TYPES };

